/** CoStar.Api.LoopNet.MobileServices.ViewModels.Confidentiality.Application */
export var Application;
(function (Application) {
    Application[Application["LoopNetAndroidMobileApp"] = 2] = "LoopNetAndroidMobileApp";
    Application[Application["LoopNetAndroidTabletApp"] = 3] = "LoopNetAndroidTabletApp";
    Application[Application["LoopNetiOSMobileApp"] = 4] = "LoopNetiOSMobileApp";
    Application[Application["LoopNetiOSTabletApp"] = 5] = "LoopNetiOSTabletApp";
})(Application || (Application = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Confidentiality.PermissionLevel */
export var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel[PermissionLevel["None"] = 0] = "None";
    PermissionLevel[PermissionLevel["Registration"] = 10] = "Registration";
    PermissionLevel[PermissionLevel["ConfidentialityAgreement"] = 20] = "ConfidentialityAgreement";
    PermissionLevel[PermissionLevel["SellerApproval"] = 30] = "SellerApproval";
})(PermissionLevel || (PermissionLevel = {}));
